$(document).ready(function () {
    var winWT = $(window).innerWidth();
    var assetsArr = $('.assets_desc_con');
    var lifecycleDescription = $('.ev_lifecycle').find('.desc');
    
    function evLifecycleForDesktop() {
        var curLifeId;
        function makeActiveLifecycle(i) {
            if (curLifeId !== i) {
                curLifeId = i;
                lifecycleDescription.css({ display: 'none' });
                $(lifecycleDescription[curLifeId]).fadeIn();
                assetsArr.removeClass('active_step');
                $(assetsArr[curLifeId]).addClass('active_step');
            }
        }
        var pinnerLifeCycle = gsap.timeline({
            scrollTrigger: {
                trigger: ".ev_lifecycle",
                start: "150px top",
                end: "bottom top",
                scrub: true,
                pin: true,
                pinSpacing: true,
                //markers: true,
                onUpdate: function (self) {
                    var indexID = Math.floor((Math.floor(self.progress * 6 + 0.5)) / 2);
                    makeActiveLifecycle(indexID);
                    var rotation = self.progress * 270;
                    gsap.set('.bike_hld', { rotate: rotation });

                }
            }
        });
    }

    function evLifecycleForMobile() {
        $('.cycle_hld').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: false,
            infinite: true,
            centerMode: true,
            centerPadding: '150px',
            speed: 400,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        centerMode: true,
                        centerPadding: '60px',
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        centerMode: true,
                        centerPadding: '40px',
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1,
                        dots: false,
                        centerMode: true,
                        centerPadding: '20px',
                    }
                }

            ]
        });
    }
    function onResizeEvCycle(){
        if (winWT >= 1024) {
            if ($('.ev_lifecycle').length > 0) {
                evLifecycleForDesktop();
            }
        } else {
            if ($('.ev_lifecycle').length > 0) {
                evLifecycleForMobile();
            }
        }
    }
    onResizeEvCycle();
    $(window).resize(function () {
        winWT = $(window).innerWidth();
        onResizeEvCycle();
    });
    
    
    /********************************************************************************/
    /********************************************************************************/
    /********************************************************************************/
    function setupSolarSteps() {
        if ($('.solar_loan_steps').length == 0) {
            return;
        }
        var solarStepsArr = $('.step_desc');
        var noOfsolarSteps = solarStepsArr.length;
        for (var i = 1; i <= solarStepsArr.length; i++) {
            $('.board_hld .step_indicators').append('<li></li>');
        }

        var curSolarStepId, newSolarStepId;
        function makeActiveStepDesc(i) {
            if (curSolarStepId !== i) {
                curSolarStepId = i;
                var tempSolarStepId = curSolarStepId;
                //console.log(curSolarStepId, tempSolarStepId);
                if (tempSolarStepId < 0) {
                    tempSolarStepId = 0;
                } else if (tempSolarStepId >= noOfsolarSteps) {
                    tempSolarStepId = noOfsolarSteps-1;
                    console.log(curSolarStepId, tempSolarStepId);
                }
                if (newSolarStepId !== tempSolarStepId) {
                    newSolarStepId = tempSolarStepId;
                    solarStepsArr.css({ display: 'none' });
                    $(solarStepsArr[newSolarStepId]).stop().fadeIn();
                }
            }
        }
        function onSolarStepProgress(progress) {
            $('.step_indicators li').removeClass('active_step');
            var indexID = Math.floor(progress * (noOfsolarSteps));
            //console.log(indexID, noOfsolarSteps);
            for (var index = 0; index <= indexID; index++) {
                $($('.step_indicators li')[index]).addClass('active_step');
            }
            makeActiveStepDesc(indexID);
        }
        onSolarStepProgress(0);
        var SolarPinner = gsap.timeline({
            scrollTrigger: {
                trigger: ".solar_loan_steps",
                start: "-50px top",
                end: "bottom top",
                scrub: true,
                pin: true,
                pinSpacing: true,
                //markers: true,
                snap: 0.1,
                onUpdate: function (self) {
                    onSolarStepProgress(self.progress);
                }
            }
        });
    }
    //setupSolarSteps();

    
    $('.solar_loan_steps .board_con').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed:5000,
        dots: true,
        fade: true,
        arrows: false,
        autoplay: true,
        infinite: true,
        speed: 400,
        responsive: [
            {
                /* breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                    centerMode: true,
                    centerPadding: '20px',
                } */
            }

        ]
    });

    
    /***************************************************************************/
    /***************************************************************************/
    function evLoanStep() {
        if ($('.steps_ev_loan').length == 0) {
            return;
        }
        var headerHT = $('header').innerHeight();
        var loanDesc = gsap.utils.toArray('.steps_mob_con .steps_slide');
        var indicators = gsap.utils.toArray('.steps_desc_con');
        var slideImgArr = $('.steps_ev_loan').find('.steps_slide');
        var numOfSteps = indicators.length;
        $(slideImgArr[0]).css({ display: 'block' });
        var curStepId, newStepId;
        function makeActiveStepImg(i) {
            if (curStepId !== i) {
                curStepId = i;
                var tempStepId = curStepId - 1;
                //console.log(curStepId, tempStepId);
                if (tempStepId < 0) {
                    tempStepId = 0;
                } else if (tempStepId >= numOfSteps) {
                    tempStepId = numOfSteps - 1;
                }
                if (newStepId !== tempStepId) {
                    newStepId = tempStepId;
                    slideImgArr.css({ display: 'none' });
                    $(slideImgArr[newStepId]).stop().fadeIn();
                }
            }
        }
        var pinner = gsap.timeline({
            scrollTrigger: {
                trigger: ".steps_ev_loan",
                start: "-10px top",
                end: "bottom top",
                scrub: true,
                pin: true,
                pinSpacing: true,
                //markers: true,
                snap: 0.1,
                onUpdate: function (self) {
                    $(indicators).removeClass('active_step');
                    var indexID = Math.floor(self.progress * (numOfSteps + 1));
                    for (var index = 0; index < indexID; index++) {
                        $(indicators[index]).addClass('active_step');

                    }
                    var perH = self.progress * (numOfSteps + 1) * 100;
                    for (var index = 0; index < numOfSteps; index++) {
                        var nPer = perH - index * 100 - 100;
                        if (nPer <= 0) {
                            nPer = 0;
                        } else if (nPer >= 100) {
                            nPer = 100
                        }
                        $($('.steps_ev_loan .progress')[index]).height(nPer + '%');
                    }
                    makeActiveStepImg(indexID);
                }
            }
        });
    }
    evLoanStep();


});